(() => {
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-kenze-card-restock]') : null;
    if (!button || button.hidden || !button.dataset.variantId || !button.dataset.productUrl) return;
    const url = new URL(button.dataset.productUrl, window.location.origin);
    if (url.origin !== window.location.origin) return;
    event.preventDefault();
    event.stopPropagation();
    url.searchParams.set('variant', button.dataset.variantId);
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.hash = 'kenze-restock';
    window.location.assign(url.toString());
  }, true);
})();
